/**
 * Product events at the mutation layer (IMPLEMENTATION.md R10 step 1): a `useMutation`
 * `onSuccess` that queues one named event and then does what the hook did before. The detail is
 * computed from the mutation's data and variables and is only ever a count, a plan, a role, a
 * kind or a state: never a field value, a name, an address or an id.
 */
import { track } from './events';

type Detail = Record<string, string | number | boolean>;

/** An `onSuccess` that tracks `name` (feature = name), with `detail` from the call, then runs `then`. */
export function tracked<D, V>(
  name: string,
  detail?: (data: D, variables: V) => Detail,
  then?: (data: D, variables: V) => unknown,
): (data: D, variables: V) => void {
  return (data, variables) => {
    track(name, { feature: name, ...(detail ? { detail: detail(data, variables) } : {}) });
    then?.(data, variables);
  };
}

/** A screen-side event with the same shape (feature = name), for handlers without a hook. */
export function trackAction(name: string, detail?: Detail): void {
  track(name, { feature: name, ...(detail ? { detail } : {}) });
}
